<template>
  <div id="reco">
    <!-- Modal de teléfono -->
    <div class="wrap-modal-phone position-absolute" v-if="isShowModalPhone">
      <div class="modal">
        <div v-if="modalPhoneNumber">
          <h2 class="mt-4 mb-3">{{ modalPhoneNumber }}</h2>
          <div class="w-75 m-auto">
            <a class="call mb-3 btn-call" :href="`tel:${modalPhoneNumber}`">Llamar</a>
          </div>
        </div>
        <div v-if="!modalPhoneNumber">
          <h4 class="mt-4">Teléfono no registrado</h4>
        </div>
        <div class="w-100 mt-4 float-left">
          <div class="d-block btn-close" @click="closeModalPhone()">cerrar</div>
        </div>
      </div>
    </div>

    <div class="padding-ios"></div>

    <!-- Tabla de servicio -->
    <table class="reco w-100 mb-3" :class="(service.state == null || service.state == 'rejected') ? 'disable' : 'active'" align="center" border="1" style="border-color: #eee">
      <tr>
        <td class="background-app" colspan="2" width="100%" align="center">SERVICIO</td>
      </tr>
      <tr>
        <td class="text-center" width="50%">
          <strong>TIPO:</strong>{{ ' ' + IDPaysType | uppercase }}
        </td>
        <td class="text-center" width="50%">{{ IDPays | uppercase }}</td>
      </tr>
      <tr v-if="service.driver_instructions">
        <td class="p-1 text-center" colspan="2">
          <strong>INFO:</strong>{{ ' ' + service.driver_instructions }}
        </td>
      </tr>
    </table>

    <!-- Tabla de pasajeros -->
    <table class="reco w-100" :class="(service.state == null || service.state == 'rejected') ? 'disable' : 'active'" align="center">
      <tr>
        <td class="background-app" colspan="7" width="100%" align="center">PASAJEROS</td>
      </tr>
      <tr class="header" height="30" bgcolor="#CCCCCC">
        <td width="30" align="center" v-if="passengersShowPhone"></td>
        <td width="22%" colspan="2" align="center" height="30">
          <strong>Nombre</strong>
        </td>
        <td width="20%" align="center">
          <strong>Dirección</strong>
        </td>
        <td width="34%" align="center">
          <strong>Comuna</strong>
        </td>
        <td width="12%" align="center">
          <strong>{{ IDPaysType == 'reco' ? 'Retiro' : 'Trasladó funcionario' }}</strong>
        </td>
      </tr>
      <tr
        v-for="passenger in service.passengers"
        :key="passenger.id"
        class="font-14"
        style="border-bottom: 1px solid #ccc"
        :bgcolor="passenger.state == 'suspendido' ? '#ccc' : (passenger.state_movil ? '#cae5fa' : '')"
      >
        <td v-if="passengersShowPhone">
          <button class="tel" @click="showModalPhone(passenger.phone)">
            <img src="/static/img/phone-call-small.png" width="24"/>
          </button>
        </td>
        <td
          class="Estilo2"
          width="22%"
          colspan="2"
          align="center"
          @click="startReco((passenger.state_movil || passenger.state == 'suspendido'), passenger.id)"
          style="height: 50px;"
          :style="{ color: (!passenger.state_movil && passenger.state !== 'suspendido') ? 'red' : '' }"
        >
          {{ passenger.name }}
        </td>
        <td width="45%" align="center">
          <a class="show-only-android" :href="`geo://?q=${passenger.localization}`" target="_blank">{{ passenger.address }}</a>
          <a class="show-only-ios" :href="`https://www.waze.com/ul?navigate=yes&ll=${passenger.localization}`" target="_blank">{{ passenger.address }}</a>
        </td>
        <td width="13%" align="center">{{ passenger.commune }}</td>
        <td width="8%" align="center" v-if="IDPaysType == 'reco'">{{ (passenger.hour_init || passenger.hour) }}</td>
        <td width="64" align="center" v-if="IDPaysType == 'zarpe'">
          <table width="100%" height="70" align="center" cellpadding="0" cellspacing="0" v-if="IDPay.state">
            <tbody v-if="!passenger.state">
              <tr>
                <td width="64" @click="setTransferState(passenger.id, passenger.number, IDPays, 'SI')" bgcolor="#00CC00" style="color:#ffffff; font-size:20px">SI</td>
              </tr>
              <tr>
                <td width="64" @click="setTransferState(passenger.id, passenger.number, IDPays, 'NO')" bgcolor="#FF0000" style="color:#ffffff; font-size:20px">NO</td>
              </tr>
            </tbody>
            <tbody v-if="passenger.state">
              <tr>
                <td width="64" style="font-size:20px">{{ passenger.state == 'NO DA POSICION' ? 'NO' : 'SI' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>

    <!-- Estado de ruta -->
    <div v-if="service.state && !finishedRoute">
      <table width="100%" height="15%" align="center" border="0" cellpadding="2" cellspacing="2">
        <tr style="border:0;">
          <td class="background-app" colspan="3" style="text-align: center ; padding: 10px 0;" align="center">
            <span style="font-size: 20px; color: #FFF; ">ESTADO DE RUTA</span>
          </td>
        </tr>
        <tr style="border:0;">
          <td style="text-align: center;  padding: 20px 0">
            <span class="color-text-app" style="font-size: 20px;">
              <strong>EL ESTADO ACTUAL DE ESTA RUTA ES "{{service.state == 'rejected' ? 'RECHAZADA' : 'ACEPTADA' }}"</strong>
            </span>
          </td>
        </tr>
      </table>
    </div>

    <!-- Confirmar ruta -->
    <div v-if="!service.state">
      <table align="center" border="0" cellpadding="2" cellspacing="2">
        <tbody>
          <tr>
            <td class="background-app" colspan="3" style="text-align: center" align="center">
              <span style="color: #FFF; ">CONFIRMAR</span>
            </td>
          </tr>
          <tr>
            <td style="text-align: center">
              <img src="/static/img/confirm.png" width="80" @click="setState('accepted', service.id_pay)"/>
            </td>
          </tr>
          <tr>
            <td style="text-align: center">
              <span><strong>PARA VER EL DETALLE POR PASAJERO, PRIMERO DEBE ACEPTAR LA RUTA</strong></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Finalizar servicio -->
    <div v-if="(finishedRoute) && service.state != 'rejected'">
      <table width="100%" height="15%" align="center" border="0" cellpadding="2" cellspacing="2">
        <tbody>
          <tr>
            <td class="background-app" colspan="3" style="text-align: center" align="center">
              <span style="font-size: 18px; color: #FFF; display: inline-block; padding: 10px 0;">FINALIZAR SERVICIO</span>
            </td>
          </tr>
          <tr v-if="service.closerServiceForCentral">
            <td style="text-align: center">
              <img src="/static/img/door.png" width="80" style="margin: 15px 0;" @click="endService(service.id_pay)"/>
            </td>
          </tr>
          <tr v-if="service.closerServiceForCentral">
            <td style="text-align: center">
              <span class="color-text-app" style="font-size: 20px; padding: 0 30px; box-sizing: border-box; width: 100%;  display: block;">
                <strong>FINALICE EL SERVICIO AL DEJAR EL ÚLTIMO PASAJERO</strong>
              </span>
            </td>
          </tr>
          <tr v-if="!service.closerServiceForCentral">
            <td>
              <img src="/static/img/alert.png" style="margin: 20px auto; display: block; width: 120px;"/>
              <p class="color-text-app" style="font-size: 20px; text-align: center; display: flex; align-items: center; justify-content: center; width: 100%;">
                <strong>SERVICIO PENDIENTE, SERÁ FINALIZADO POR LA CENTRAL</strong>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Volver a aeropuerto -->
    <table align="center" width="100%">
      <tr style="border:0">
        <td align="center" colspan="5" height="65" valign="middle" style="vertical-align: middle">
          <span>
            <strong>
              <a class="show-only-android" href="geo://?q=-33.396792,-70.793338" target="_blank" style="text-decoration:none;">VOLVER A AEROPUERTO</a>
              <a class="show-only-ios" href="https://www.waze.com/ul?navigate=yes&ll=-33.396792,-70.793338" target="_blank" style="text-decoration:none;">VOLVER A AEROPUERTO</a>
            </strong>
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Reco',
  data() {
    return {
      service: {},
      IDPays: '',
      IDPaysType: '',
      IDPay: {},
      passengersShowPhone: false,
      finishedRoute: false,
      isShowModalPhone: false,
      modalPhoneNumber: ''
    }
  },
  created() {
    this.loadRecoData()
  },
  filters: {
    uppercase(value) {
      return value ? value.toUpperCase() : ''
    },
    limitTo(value, limit) {
      return value ? value.substring(0, limit) : ''
    }
  },
  methods: {
    async fetchAppPassengersShowPhone() {
      try {
        const response = await http.get('app/settings/app_passengers_show_phone')
        this.passengersShowPhone = response.body.success === true
      } catch (err) {
        console.error('Error fetching passengers show phone setting:', err)
        this.passengersShowPhone = false
      }
    },
    loadRecoData() {
      const recoId = this.$route.params.id
      this.IDPay = { id: recoId, state: true } // Asignar el ID correctamente

      this.fetchAppPassengersShowPhone()

      http.get(`app/service/${recoId}`)
        .then(res => {
          this.service = res.body.service
          this.IDPays = recoId
          this.IDPaysType = 'reco'
          this.finishedRoute = true

          // Lógica para closerServiceForCentral
          this.service.closerServiceForCentral = true
          if (this.service.rtx_type === 'km' ||
              this.service.rtx_type === 'backup' ||
              this.service.rtx_type === 'apoyo bus mant' ||
              this.service.rtx_type === 'apoyo bus corp') {
            this.service.closerServiceForCentral = false
          }

          // Verificar si todos los pasajeros están procesados
          this.service.passengers.forEach(passenger => {
            if (!passenger.state_movil) {
              this.finishedRoute = false
            }
          })
        })
        .catch(err => {
          console.error('Error loading reco data:', err)
        })
    },
    showModalPhone(phone) {
      this.modalPhoneNumber = phone
      this.isShowModalPhone = true
    },
    closeModalPhone() {
      this.isShowModalPhone = false
      this.modalPhoneNumber = ''
    },
    startReco(isDisabled, passengerId) {
      if (isDisabled) return
      this.$router.push(`/recos/${this.service.id_pay}/start/${passengerId}`)
    },
    setState(state, idPay) {
      if (confirm('¿Está seguro?')) {
        http.put(`app/service/${idPay}/state/${state}`, { reason: false })
          .then(res => {
            this.service.state = state
            this.finishedRoute = false
            if (state === 'rejected') {
              this.$router.push('/recos')
            }
            this.loadRecoData()
          })
          .catch(err => {
            console.error('Error setting state:', err)
          })
      }
    },
    setTransferState(passengerId, passengerNumber, idPays, state) {
      http.put(`app/passenger/${passengerId}/transfer/${passengerNumber}`)
        .then(res => {
          this.loadRecoData()
        })
        .catch(err => {
          console.error('Error setting transfer state:', err)
        })
    },
    endService(idPay) {
      http.post(`app/rates/finished/${idPay}`)
        .then(res => {
          alert(`Servicio: ${idPay} finalizado`)
          this.$router.push('/menu')
        })
        .catch(err => {
          console.error('Error ending service:', err)
          this.$router.push('/menu')
        })
    }
  }
}
</script>

<style lang="css">
.wrap-modal-phone {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrap-modal-phone .modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  height: 32% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reco.vue